// eslint-disable-next-line
if (!global._babelPolyfill) {
  // eslint-disable-next-line
  require('@babel/polyfill');
}
